var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6334 14.975H5.36669C2.05002 14.975 1.04169 13.9666 1.04169 10.65V5.36663C1.04169 2.04996 2.05002 1.04163 5.36669 1.04163H14.625C17.9417 1.04163 18.95 2.04996 18.95 5.36663V10.6416C18.9584 13.9666 17.95 14.975 14.6334 14.975ZM5.36669 2.29163C2.75002 2.29163 2.29169 2.74996 2.29169 5.36663V10.6416C2.29169 13.2583 2.75002 13.7166 5.36669 13.7166H14.625C17.2417 13.7166 17.7 13.2583 17.7 10.6416V5.36663C17.7 2.74996 17.2417 2.29163 14.625 2.29163H5.36669Z",
    fill: "#909AB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.9583C9.65833 18.9583 9.375 18.675 9.375 18.3333V14.35C9.375 14.0083 9.65833 13.725 10 13.725C10.3417 13.725 10.625 14.0083 10.625 14.35V18.3333C10.625 18.675 10.3417 18.9583 10 18.9583Z",
    fill: "#909AB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 11.4584H1.66669C1.32502 11.4584 1.04169 11.175 1.04169 10.8334C1.04169 10.4917 1.32502 10.2084 1.66669 10.2084H18.3334C18.675 10.2084 18.9584 10.4917 18.9584 10.8334C18.9584 11.175 18.675 11.4584 18.3334 11.4584Z",
    fill: "#909AB4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 18.9584H6.25C5.90833 18.9584 5.625 18.675 5.625 18.3334C5.625 17.9917 5.90833 17.7084 6.25 17.7084H13.75C14.0917 17.7084 14.375 17.9917 14.375 18.3334C14.375 18.675 14.0917 18.9584 13.75 18.9584Z",
    fill: "#909AB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.882bd6d8bec0ac8b5af3f88889f0062b.svg";
export { ForwardRef as ReactComponent };